<div class="date-range-picker">
  <div class="d-inline-flex date">
    <div class="form-group ps-0">
      <label class="fw-bold form-label">{{localize(langSection.DatePicker, langText.StartDate)}}</label>
      <datepicker [showUnreadCommentMeatballs]="true" [(date)]="fromDate" [disableBefore]="lowerLimit"
        [disableAfter]="upperLimit" (onChange)="onFromDateChanged($event)"></datepicker>
    </div>
  </div>
  <div class="d-inline-flex align-items-center justify-content-center date-separator px-2">
    <span>{{localize(langSection.Term, langText.To)}}</span>
  </div>
  <div class="d-inline-flex date">
    <div class="form-group ps-0 position-relative">
      <label class="fw-bold form-label">{{localize(langSection.DatePicker, langText.EndDate)}}</label>
      <datepicker class="wide-screen date-picker-wrapper" [showUnreadCommentMeatballs]="true" [date]="toDate" [disableBefore]="lowerLimit"
        [disableAfter]="upperLimit" (onChange)="onToDateChanged($event)"></datepicker>
      <datepicker class="small-screen date-picker-wrapper" [showUnreadCommentMeatballs]="true" [date]="toDate" [disableBefore]="lowerLimit"
        [disableAfter]="upperLimit" (onChange)="onToDateChanged($event)" [placement]="'bottom-right'"></datepicker>
    </div>
  </div>
</div>